// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chubb-footer {
    padding: 20px 0;
    background-color: var(--footer-background);
}
.chubb-logo {
    padding-right: 16px;
    margin-right: 16px;
    height: 16px;
}

/* social icons */
.social-icons {
    height: 16px;
}
.social-icons a {
    margin-left: 32px;
}
.social-icons a img {
    fill: #fff;
    filter: invert(1);
    height: 16px;
    position: relative;
    top: -6px;
}

/* copyright */
.copyright {
    padding: 14px 0;
    font-size: 14px;
    color: #e8e8e8;
}
.disclaimer {
    border-top: solid 1px var(--color-light-gray);
    padding-top: 0;
    color: #a2a2a2;
    font-size: 14px;
}

/* responsive classes */
@media only screen and (max-width: 1024px) {
    .chubb-footer {
        padding: 24px 0;
    }
    .copyright {
        padding: 22px 0;
    }
    .disclaimer {
        padding-top: 20px;
    }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNoLWZvb3Rlci5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksZUFBZTtJQUNmLDBDQUEwQztBQUM5QztBQUNBO0lBQ0ksbUJBQW1CO0lBQ25CLGtCQUFrQjtJQUNsQixZQUFZO0FBQ2hCOztBQUVBLGlCQUFpQjtBQUNqQjtJQUNJLFlBQVk7QUFDaEI7QUFDQTtJQUNJLGlCQUFpQjtBQUNyQjtBQUNBO0lBQ0ksVUFBVTtJQUNWLGlCQUFpQjtJQUNqQixZQUFZO0lBQ1osa0JBQWtCO0lBQ2xCLFNBQVM7QUFDYjs7QUFFQSxjQUFjO0FBQ2Q7SUFDSSxlQUFlO0lBQ2YsZUFBZTtJQUNmLGNBQWM7QUFDbEI7QUFDQTtJQUNJLDZDQUE2QztJQUM3QyxjQUFjO0lBQ2QsY0FBYztJQUNkLGVBQWU7QUFDbkI7O0FBRUEsdUJBQXVCO0FBQ3ZCO0lBQ0k7UUFDSSxlQUFlO0lBQ25CO0lBQ0E7UUFDSSxlQUFlO0lBQ25CO0lBQ0E7UUFDSSxpQkFBaUI7SUFDckI7QUFDSiIsImZpbGUiOiJjaC1mb290ZXIuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jaHViYi1mb290ZXIge1xuICAgIHBhZGRpbmc6IDIwcHggMDtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1mb290ZXItYmFja2dyb3VuZCk7XG59XG4uY2h1YmItbG9nbyB7XG4gICAgcGFkZGluZy1yaWdodDogMTZweDtcbiAgICBtYXJnaW4tcmlnaHQ6IDE2cHg7XG4gICAgaGVpZ2h0OiAxNnB4O1xufVxuXG4vKiBzb2NpYWwgaWNvbnMgKi9cbi5zb2NpYWwtaWNvbnMge1xuICAgIGhlaWdodDogMTZweDtcbn1cbi5zb2NpYWwtaWNvbnMgYSB7XG4gICAgbWFyZ2luLWxlZnQ6IDMycHg7XG59XG4uc29jaWFsLWljb25zIGEgaW1nIHtcbiAgICBmaWxsOiAjZmZmO1xuICAgIGZpbHRlcjogaW52ZXJ0KDEpO1xuICAgIGhlaWdodDogMTZweDtcbiAgICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gICAgdG9wOiAtNnB4O1xufVxuXG4vKiBjb3B5cmlnaHQgKi9cbi5jb3B5cmlnaHQge1xuICAgIHBhZGRpbmc6IDE0cHggMDtcbiAgICBmb250LXNpemU6IDE0cHg7XG4gICAgY29sb3I6ICNlOGU4ZTg7XG59XG4uZGlzY2xhaW1lciB7XG4gICAgYm9yZGVyLXRvcDogc29saWQgMXB4IHZhcigtLWNvbG9yLWxpZ2h0LWdyYXkpO1xuICAgIHBhZGRpbmctdG9wOiAwO1xuICAgIGNvbG9yOiAjYTJhMmEyO1xuICAgIGZvbnQtc2l6ZTogMTRweDtcbn1cblxuLyogcmVzcG9uc2l2ZSBjbGFzc2VzICovXG5AbWVkaWEgb25seSBzY3JlZW4gYW5kIChtYXgtd2lkdGg6IDEwMjRweCkge1xuICAgIC5jaHViYi1mb290ZXIge1xuICAgICAgICBwYWRkaW5nOiAyNHB4IDA7XG4gICAgfVxuICAgIC5jb3B5cmlnaHQge1xuICAgICAgICBwYWRkaW5nOiAyMnB4IDA7XG4gICAgfVxuICAgIC5kaXNjbGFpbWVyIHtcbiAgICAgICAgcGFkZGluZy10b3A6IDIwcHg7XG4gICAgfVxufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/marina-design/ch-footer/ch-footer.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,0CAA0C;AAC9C;AACA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA,iBAAiB;AACjB;IACI,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA,cAAc;AACd;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;AACA;IACI,6CAA6C;IAC7C,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA,g5DAAg5D","sourcesContent":[".chubb-footer {\n    padding: 20px 0;\n    background-color: var(--footer-background);\n}\n.chubb-logo {\n    padding-right: 16px;\n    margin-right: 16px;\n    height: 16px;\n}\n\n/* social icons */\n.social-icons {\n    height: 16px;\n}\n.social-icons a {\n    margin-left: 32px;\n}\n.social-icons a img {\n    fill: #fff;\n    filter: invert(1);\n    height: 16px;\n    position: relative;\n    top: -6px;\n}\n\n/* copyright */\n.copyright {\n    padding: 14px 0;\n    font-size: 14px;\n    color: #e8e8e8;\n}\n.disclaimer {\n    border-top: solid 1px var(--color-light-gray);\n    padding-top: 0;\n    color: #a2a2a2;\n    font-size: 14px;\n}\n\n/* responsive classes */\n@media only screen and (max-width: 1024px) {\n    .chubb-footer {\n        padding: 24px 0;\n    }\n    .copyright {\n        padding: 22px 0;\n    }\n    .disclaimer {\n        padding-top: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
